// The lighting rig for the detail stage, tuned for the light theme. The models
// themselves are unlit — their faceted low-poly shading is baked into vertex
// colours by buildModel — so this rig exists to light the stage *around* the
// model: the ground plane and the pedestal, and to cast the model's soft contact
// shadow onto them. (Gallery thumbnails have no ground, so they need no lights.)

import * as THREE from "three";

/**
 * Add the studio lights to `scene`. With `shadows` the key light casts a soft
 * shadow (the detail stage uses it for the pedestal); thumbnails skip it for
 * speed. Returns the key light so the caller can aim it if needed.
 */
export function addStudioLights(scene: THREE.Scene, shadows: boolean): THREE.DirectionalLight {
  const sun = new THREE.DirectionalLight(0xffffff, 2.3);
  sun.position.set(-5, 9, -3);
  if (shadows) {
    sun.castShadow = true;
    sun.shadow.mapSize.set(2048, 2048);
    sun.shadow.camera.near = 0.5;
    sun.shadow.camera.far = 60;
    Object.assign(sun.shadow.camera as THREE.OrthographicCamera, { left: -8, right: 8, top: 8, bottom: -8 });
    sun.shadow.bias = -0.0007;
  }
  scene.add(sun, sun.target);

  // Fill from the opposite side (never shadows) so shadowed faces still read.
  const fill = new THREE.DirectionalLight(0xeaf1ff, 0.9);
  fill.position.set(6, 5, 6);
  scene.add(fill);

  // Sky/ground ambient plus a small flat floor — nothing ever drops to black.
  scene.add(new THREE.HemisphereLight(0xffffff, 0xc4ccd6, 1.1));
  scene.add(new THREE.AmbientLight(0xffffff, 0.35));
  return sun;
}
